import { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import * as services from "../../services/services";

export default function HospitalCreatePage() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    address: "",
    phoneNumber: "",
    email: "",
    subDistrict: "",
    district: "",
    province: "",
    image: "",
    imageFile: null,
  });

  const [imagePreview, setImagePreview] = useState(null);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image" && files?.[0]) {
      const file = files[0];

      setImagePreview(URL.createObjectURL(file));

      setForm({
        ...form,
        imageFile: file,
      });

      return;
    }

    setForm({
      ...form,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    try {
      if (!form.name) {
        toast.error("กรุณากรอกชื่อโรงพยาบาล");
        return;
      }

      let imageUrl = "";

      // 🔥 upload image
      if (form.imageFile) {
        const uploadRes = await services.uploadImage(
          form.imageFile,
          "hospital"
        );
        imageUrl = uploadRes.data.url;
      }

      // 🔥 create hospital
      await services.createHospital({
        name: form.name,
        address: form.address,
        phoneNumber: form.phoneNumber,
        email: form.email,
        subDistrict: form.subDistrict,
        district: form.district,
        province: form.province,
        image: imageUrl,
      });

      toast.success("สร้างโรงพยาบาลสำเร็จ");
      navigate("/hospitals/list");
    } catch (err) {
      toast.error("สร้างไม่สำเร็จ");
    }
  };

  return (
    <Box maxWidth={900} mx="auto">
      <Typography variant="h5" fontWeight={600} mb={3}>
        เพิ่มโรงพยาบาล
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 2fr" },
          gap: 4,
        }}
      >
        {/* 📸 IMAGE */}
        <Box
          sx={{
            border: "2px dashed #ddd",
            borderRadius: 3,
            p: 2,
            textAlign: "center",
            cursor: "pointer",
            minHeight: 250,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#fafafa",
          }}
          onClick={() =>
            document.getElementById("hospital-image")?.click()
          }
        >
          {imagePreview ? (
            <img
              src={imagePreview}
              alt="preview"
              style={{
                width: 180,
                height: 180,
                objectFit: "cover",
                borderRadius: 12,
              }}
            />
          ) : (
            <Typography color="text.secondary">
              คลิกเพื่ออัปโหลดโลโก้
            </Typography>
          )}

          <input
            id="hospital-image"
            type="file"
            hidden
            accept="image/*"
            name="image"
            onChange={handleChange}
          />
        </Box>

        {/* 🧾 FORM */}
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="ชื่อโรงพยาบาล *"
                name="name"
                value={form.name}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="ที่อยู่"
                name="address"
                value={form.address}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                label="ตำบล"
                name="subDistrict"
                value={form.subDistrict}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                label="อำเภอ"
                name="district"
                value={form.district}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                label="จังหวัด"
                name="province"
                value={form.province}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="เบอร์โทรศัพท์"
                name="phoneNumber"
                value={form.phoneNumber}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Email"
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
          </Grid>

          <Box mt={3} display="flex" gap={2}>
            <Button variant="contained" onClick={handleSubmit}>
              บันทึก
            </Button>

            <Button
              variant="outlined"
              onClick={() => navigate("/hospitals/list")}
            >
              ยกเลิก
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
